import { Key } from "react"
import {
  LabelSmall,
  Tab,
  TabProps as ClayTabProps,
  Tabs as ClayTabs,
  TabsProps as ClayTabsProps,
  useStyletron,
} from "@mezo-org/mezo-clay"

export type TabsProps = Omit<ClayTabsProps, "onChange" | "children"> & {
  onChange: (key: Key) => void
  tabs: ClayTabProps[]
}

export default function Tabs({
  onChange,
  activeKey,
  tabs,
  ...props
}: TabsProps) {
  const [, theme] = useStyletron()

  return (
    <ClayTabs
      onChange={({ activeKey: key }) => onChange(key)}
      activeKey={activeKey}
      overrides={{
        TabList: { style: () => ({ marginBottom: `-${theme.sizing.scale0}` }) },
        TabBorder: { style: () => ({ height: theme.sizing.scale0 }) },
        TabHighlight: { style: () => ({ height: theme.sizing.scale0 }) },
      }}
      {...props}
    >
      {tabs.map(({ key, title, children, ...tabProps }) => (
        <Tab
          title={title}
          key={key}
          overrides={{
            TabPanel: { style: () => ({ paddingLeft: 0, paddingRight: 0 }) },
            Tab: {
              component: LabelSmall,
              style: () => ({
                cursor: "pointer",
                padding: theme.sizing.scale600,
                background: "transparent",
                color:
                  activeKey === key
                    ? theme.colors.black
                    : theme.colors.contentTertiary,
              }),
            },
          }}
          {...tabProps}
        >
          {children}
        </Tab>
      ))}
    </ClayTabs>
  )
}
